import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=10af1eca&"
import script from "./UserStatistics.vue?vue&type=script&lang=ts&"
export * from "./UserStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports